import * as Types from "../../../constants";
export const login = (state = {userRole: "admin"}, action) => {
  switch (action.type) {
    case "LOGIN_ADMIN": {
      return {...state, user: action.user}
    }
    case "CHANGE_ROLE": {
      return {...state, userRole: action.userRole}
    }
    case Types.AUTH_USER:
      return {
        ...state, user: action.payload ? action.payload.data : null
      };

    default: {
      return state
    }
  }
}
